import { TranslateService } from '@ngx-translate/core';

export const LanguagesList = [
    {
      code: 'en',
      name: 'english',
      flag: 'assets/media/flags/united-states.png',
    },
    {
      code: 'nl',
      name: 'dutch',
      flag: 'assets/media/flags/netherlands.png',
    },
    {
      code: 'tr',
      name: 'turkish',
      flag: 'assets/media/flags/turkey.png',
    },
    {
      code: 'fr',
      name: 'french',
      flag: 'assets/media/flags/france.png',
    },
    {
      code: 'de',
      name: 'german',
      flag: 'assets/media/flags/germany.png',
    },
    {
      code: 'es',
      name: 'spanish',
      flag: 'assets/media/flags/spain.png',
    },
    {
      code: 'it',
      name: 'italian',
      flag: 'assets/media/flags/italy.png',
    },
    {
      code: 'da',
      name: 'danish',
      flag: 'assets/media/flags/denmark.png',
    },
    {
      code: 'sv',
      name: 'swedish',
      flag: 'assets/media/flags/sweden.png',
    },
    {
      code: 'no',
      name: 'norwegian',
      flag: 'assets/media/flags/norway.png',
    },
    {
      code: 'fi',
      name: 'finnish',
      flag: 'assets/media/flags/finland.png',
    },
];

export function getTranslatedLanguages(translate: TranslateService) {
    return LanguagesList.map(lang => ({
        ...lang,
        name: translate.instant(lang.name)
    }));
} 